import { BadgeCheck } from "lucide-react";

export default function VerifiedBadge({ user, size = "sm", className = "" }) {
  if (!user) return null;
  const tier = user.subscription_tier;
  const isPro = tier === "pro" || tier === "pro_yearly";
  if (!(user.subscription_active && isPro)) return null;
  const dims = size === "lg" ? "text-sm px-2.5 py-1" : "text-[11px] px-2 py-0.5";
  return (
    <span
      data-testid={`verified-badge-${user.user_id || ""}`}
      className={`inline-flex items-center gap-1 rounded-full bg-gradient-to-r from-amber-100 to-amber-200 text-amber-800 font-semibold border border-amber-300 ${dims} ${className}`}
      title="Verified Annual Member"
    >
      <BadgeCheck className={size === "lg" ? "w-4 h-4" : "w-3 h-3"} />
      Verified
    </span>
  );
}
